import { Box, Flex, SimpleGrid } from '@chakra-ui/react';
import type React from 'react';
import type { UploadedFile } from '@/hooks';
import { getFileIcon } from '@/utils/fileUtils';
import FaceliftText from '@/components/Atoms/FaceliftText';
import Show from '@/components/Molecules/Show';

export interface FilePreviewListProps {
	files: UploadedFile[];
	onDelete?: (fileId: string) => void;
	formatFileSize: (bytes: number) => string;
}

const FilePreviewList: React.FC<FilePreviewListProps> = ({
	files,
	onDelete,
	formatFileSize,
}) => {
	if (files.length === 0) return null;

	return (
		<Box mt={{ base: 4, md: 6 }} width="full">
			<SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} gap={{ base: 2, md: 3 }}>
				{files.map((file) => {
					const FileIcon = getFileIcon(file.name, file.type);
					
					return (
						<Flex
							key={file.id}
							align="center"
							gap={{ base: 1.5, md: 2 }}
							p={{ base: 1, md: 1 }}
							bg="brand.input.bg"
							borderRadius="sm"
							border="1px solid"
							borderColor="brand.input.placeholder"
							width="full"
							minHeight={{ base: 7, md: 7 }}
						>
							<Box flexShrink={0}>
								<FileIcon width={16} height={16} />
							</Box>
						<Box flex={1} minWidth={0} overflow="hidden">
							<FaceliftText
								fontSize={{ base: '2xs', sm: 'xs' }}
								fontWeight="medium"
								color="brand.input.text"
								lineHeight="1.2"
								whiteSpace="nowrap"
								overflow="hidden"
								textOverflow="ellipsis"
							>
								{file.name}
							</FaceliftText>
							<Show when={file.size > 0}>
								<FaceliftText
									fontSize={{ base: '2xs', sm: '2xs' }}
									color="brand.input.placeholder"
									lineHeight="1.2"
									whiteSpace="nowrap"
								>
									{formatFileSize(file.size)}
								</FaceliftText>
							</Show>
						</Box>
						<Show when={!!onDelete}>
							<Box
								as="button"
								onClick={() => onDelete?.(file.id)}
								cursor="pointer"
								p={{ base: 0.5, md: 1 }}
								color="brand.input.text"
								_hover={{ opacity: 0.7 }}
								flexShrink={0}
							>
								<FaceliftText fontSize={{ base: 'lg', md: 'xl' }}>×</FaceliftText>
							</Box>
						</Show>
						</Flex>
					);
				})}
			</SimpleGrid>
		</Box>
	);
};

export default FilePreviewList;
